import drawingWithClaude from "./drawing-with-claude";
import designStack2026 from "./design-stack-2026";
import designerVibecodesDesignEngineer from "./designer-vibecodes-design-engineer";
import onTaste from "./on-taste/index";
import japaneseColors from "./japanese-colors";

export type { Writing, WritingBlock, WritingImage } from "./types";

export const writings = [
  drawingWithClaude,
  onTaste,
  designerVibecodesDesignEngineer,
  designStack2026,
  japaneseColors,
];
